import { t } from "@redotech/redo-i18n";
import { Condition } from "@redotech/redo-return-core-common/return-flow/condition";
import { NumClaimsOption } from "@redotech/redo-return-core-common/return-flow/condition-enums";
import { CONDITION_NAMES } from "@redotech/redo-return-core-common/return-flow/condition-names";
import {
  numCustomerClaimsFromModel,
  validateNumCustomerClaimsCondition,
  type NumCustomerClaimsState,
} from "@redotech/redo-return-core-common/return-flow/condition-validate";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export const NUM_CUSTOMER_CLAIMS = (
  Details: React.ComponentType<
    ConditionTypeDetailsProps<NumCustomerClaimsState>
  >,
): ConditionType<NumCustomerClaimsState, Condition.NumCustomerClaims> => ({
  name: CONDITION_NAMES[Condition.NUM_CUSTOMER_CLAIMS],
  description(state) {
    if (!state.claimOption) {
      return t("The total number of claims this customer has previously made");
    }
    switch (state.claimOption) {
      case NumClaimsOption.LESS_THAN:
        return t("Number of previous claims less than {{value}}", {
          value: state.numClaims,
        });
      case NumClaimsOption.GREATER_THAN:
        return t("Number of previous claims greater than {{value}}", {
          value: state.numClaims,
        });
    }
  },
  Details(props: ConditionTypeDetailsProps<NumCustomerClaimsState>) {
    return React.createElement(Details, props);
  },
  empty: { numClaims: (0).toFixed(0), claimOption: null },
  fromModel(model) {
    return numCustomerClaimsFromModel(model);
  },
  toModel(state) {
    return {
      type: Condition.NUM_CUSTOMER_CLAIMS,
      numClaims: +state.numClaims,
      numClaimsOption: state.claimOption,
    };
  },
  valid(state) {
    return validateNumCustomerClaimsCondition(state).valid;
  },
});
